import { Toro } from '../../common/enumerations';
import RunningMode = Toro.RunningMode;

export class RunningModeChangeAcceptedNotificationModel
{
    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
        }
    }

    public ControllerId: number;
    public RunningMode: RunningMode;
    public RunningModeDaysToRemainOff: number;
    public TypeCode: number;
    public WasConfigurationSuccessfullyDelivered = false;
}
